var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.formController(_vm.url, $event)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Message")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.message,
                  expression: "model.message"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "message", name: "message", rows: "3" },
              domProps: { value: _vm.model.message },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.model, "message", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "error invalid-feedback",
              attrs: { id: "message-error" }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            { staticClass: "btn btn-primary", attrs: { type: "submit" } },
            [_vm._v(_vm._s(_vm.submitText))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _vm.successMessage
            ? _c("div", { staticClass: "success-message" }, [
                _vm._v(_vm._s(_vm.successMessage))
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }